import styles from "./main.module.scss";
import { logout } from "../../utils/logout";

interface LogoutButtonProps {
  handleClose: () => void; // Props to handle closing the logout confirmation
}

const Main: React.FC<LogoutButtonProps> = ({ handleClose }) => {
  return (
    <div>
      <div className={styles.textContainer}>
        <p>Are you sure you want to log out?</p>
      </div>

      <div className={styles.btnContainer}>
        <button className={styles.closeButton} onClick={handleClose}>
          Cancel
        </button>
        <button className={styles.logoutButton} onClick={logout}>
          Log out
        </button>
      </div>
    </div>
  );
};

export default Main;
